import Firebase from 'firebase/app'
import ReactGA from 'react-ga'

import { prepareDocForCreate } from './helpers/firestoreHelpers'

const createTouch = values => {

  ReactGA.event({
    category: 'Touch',
    action: 'Add touch',
  })

  if (!values.date) {
    values.date = new Date()
  }

  return Firebase.firestore()
    .collection('touches')
    .add(prepareDocForCreate(values))
    .then( () => values)
    .catch( error => {
      alert(`Whoops, couldn't add the touch: ${error.message}`)
    })
}

export default createTouch



// WEBPACK FOOTER //
// ./src/actions/createTouch.js